import { Coin, CreateTxOptions, TxInfo } from "@terra-money/terra.js";
import React, { createContext, useRef, useState, } from "react";
import { MessageDetail, WasmTx } from "wasmx";
import { useWasmX } from "@hooks/WasmXHook";

type CallbackProp = {
    onSuccess?: (tx: TxInfo) => void,
    onError?: (e: Error) => void
}

type TxModalContextProps = {
    wasmTx?: WasmTx,
    callback?: CallbackProp,
    show: (sender: string, messages: MessageDetail[], memo: string, callback?: CallbackProp) => Promise<void>,
    hide: (reason?: Error) => void
}

export const TxModalContext = createContext<TxModalContextProps>({
    show: async () => { },
    hide: () => { }
})

export const TxModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [wasmTx, setWasmTx] = useState<WasmTx>()
    const [callback, setCallback] = useState<CallbackProp>();
    const wasm = useWasmX()

    const show = async (sender: string, messages: MessageDetail[], memo: string, callback?: CallbackProp) => {
        if (!wasm) throw new Error("Cannot connect to blockchain, try to refresh the page")

        setCallback(callback)

        const wasmTx = await wasm.buildWasmTx(sender, messages, memo)
        setTimeout(() => setWasmTx(wasmTx), 100)
    }

    const hide = (reason?: Error) => {
        setTimeout(() => {
            if (reason) callback?.onError?.call(null, reason)
            setWasmTx(undefined)
            setCallback(undefined)
        }, 100)
    }

    return (
        <TxModalContext.Provider
            value={{
                wasmTx,
                hide,
                show,
                callback,
            }}
        >
            {children}
        </TxModalContext.Provider>
    );
}